import { render } from "./GpError.vue?vue&type=template&id=d950f6ec&scoped=true"
import script from "./GpError.vue?vue&type=script&lang=js"
export * from "./GpError.vue?vue&type=script&lang=js"

import "./GpError.vue?vue&type=style&index=0&id=d950f6ec&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d950f6ec"]])

export default __exports__